import styles from "./page-header.module.css";
import { createElement } from "react";
import { useLocation } from "react-router-dom";
import { panelIconForPath } from "@/lib/panel-navigation";

export function PageTitle({
  title,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description: string;
  actions?: React.ReactNode;
}) {
  const { pathname } = useLocation();

  return (
    <header className={styles.header}>
      <div className={styles.identity}>
        <span aria-hidden="true" className={styles.iconTile}>
          {createElement(panelIconForPath(pathname), { size: 17, strokeWidth: 1.8 })}
        </span>
        <h1>{title}</h1>
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}

export const PageHeader = PageTitle;
